import {Component, Inject, OnInit} from '@angular/core';
import {CasinoBetsService} from "../../../services/casino/casino-bets.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {UserService} from "../../../services/user.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-baccarat2',
  templateUrl: './baccarat2.component.html',
  styleUrls: ['./baccarat2.component.css']
})
export class Baccarat2ResultComponent implements OnInit {

  details: any = {};
  player1: any = [];
  player2: any = [];
  tables: any = [];
  winner: any = '';
  cards: any = '';
  casino_bets: any = [];
  filter_bets: any = [];
  totalbets: number = 0;
  totalAmount: number = 0;
  result_baccarat2:any = [];
  winner_pair:any = [];
  playerCards:any=[];
  bankerCards:any=[];
  win:any = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private casinoBetsService: CasinoBetsService, private router: Router, public dialogRef: MatDialogRef<any>, private fb: FormBuilder, private userService: UserService, private toasterService: ToastrService) {

  }

  ngOnInit(): void {
      this.dialogRef.updateSize('100%',);
      if(!this.data.acc_state){
        this.getBaccarat2Details();
        }else{
          this.getCasinoResultonMarketId();
        }
      this.getCasinoBetsByMarketID();
  }

  getCasinoResultonMarketId(){
    this.casinoBetsService.getCasinoResultonMarketId(this.data.mid).subscribe((res:any)=>{
      if(res.length>0){
      const renamedObject = {
        ...res[0],          // Copy all existing properties
        desc: res[0].description, // Rename description to desc
        cards: res[0].result // Rename result to cards
      };
      console.log("renamedObject",renamedObject);
      this.extractResultFromData(renamedObject)
    }
    })
  }


  getBaccarat2Details() {
      this.casinoBetsService.getTeenPattiDetails(this.data.mid).subscribe((res: any) => {
          if (res.success) {
              this.details = res.data;
              console.log('xxx--------->', this.details);
              // this.getResults(this.details[0]);
              this.extractResultFromData(this.details[0])
          }else{
            const renamedObject = {
              ...this.data.stored_data,          // Copy all existing properties
              desc: this.data.stored_data.description, // Rename description to desc
              cards: this.data.stored_data.result // Rename result to cards
            };
            this.extractResultFromData(renamedObject)
          }
      });
  }

  private getResults(data: any) {
      const [player1, player2, tables] = this.divideIntoArrays(data.cards);
      this.player1 = player1;
      this.player2 = player2;
      this.tables = tables;
      this.winner = data.desc;
      this.cards = this.getFirstCharacters(data.cards);
  }

  private divideIntoArrays(playerString: string) {
      // Split the string by comma
      const players = playerString.split(",");

      // Initialize empty arrays
      const player1 = [];
      const player2 = [];
      const tables = [];

      // Loop through players, assigning first two to player1, second two to player2, and remaining to table
      for (let i = 0; i < players.length; i++) {
          if (i < 2) {
              player1.push(players[i]);
          } else if (i < 4) {
              player2.push(players[i]);
          } else {
              tables.push(players[i]);
          }
      }

      // Return an object containing the arrays
      return [player1, player2, tables];
  }

  private getFirstCharacters(inputString: string) {
      const gameArray = inputString.split(',');
      const result = gameArray.map(game => game.charAt(0));
      return result.join(' ');
  }

  getCasinoBetsByMarketID() {
      this.casinoBetsService.getCasinoBetsByOnlyMarketId(this.data.mid).subscribe((res: any) => {
          console.log('filter_bets data', res);
          this.casino_bets = res;
          this.filter_bets = this.casino_bets;
          this.totalbets = this.casino_bets.length;
          this.totalAmount = this.casino_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
      });
  }

  private extractResultFromData(result: any) {
    let desc = result.desc;
    let cards = result.cards;
    this.win = result.win;
    this.winner = result.desc;
    if (result.cards.length > 0) {
      if (result.desc != "Tie Game") {
        const cardValues :any= {
          A: 1,
          2: 2,
          3: 3,
          4: 4,
          5: 5,
          6: 6,
          7: 7,
          8: 8,
          9: 9,
          10: 0,
          J: 0,
          Q: 0,
          K: 0,
          1: 0, // Adding special case for card with value 1
        };

        const cardArray = cards.split(",");
        let playerCards = [];
        let bankerCards = [];

        for (let i = 0; i < cardArray.length; i++) {
          if (i % 2 === 0) {
            playerCards.push(cardArray[i]);
          } else {
            bankerCards.push(cardArray[i]);
          }
        }
        this.playerCards =  playerCards.filter(item => item !== '1');
        this.bankerCards = bankerCards.filter(item => item !== '1');

        console.log(`Player Cards: ${playerCards}`);
        console.log(`Banker Cards: ${bankerCards}`);

        const selectedCards = desc === "Player" ? playerCards : bankerCards;

        const totalScore =
          selectedCards.reduce((total, card) => {
            let cardValue = card.match(/^\d+|^[A-Z]/)[0]; // Extract only the number or face value
            // console.log(
            //   `Card: ${card}, Card Value: ${cardValue}, Mapped Value: ${cardValues[cardValue]}`
            // );
            return (
              total +
              (cardValues[cardValue] !== undefined
                ? cardValues[cardValue]
                : 0)
            );
          }, 0) % 10;

        // console.log(`Total Score: ${totalScore}`);

        const playerPair =
          playerCards.length > 1 &&
          playerCards[0].match(/^\d+|^[A-Z]/)[0] ===
            playerCards[1].match(/^\d+|^[A-Z]/)[0];
        const bankerPair =
          bankerCards.length > 1 &&
          bankerCards[0].match(/^\d+|^[A-Z]/)[0] ===
            bankerCards[1].match(/^\d+|^[A-Z]/)[0];

        if (totalScore >= 1 && totalScore <= 4) {
          this.result_baccarat2.push("Score 1-4");
        } else if (totalScore >= 5 && totalScore <= 6) {
          this.result_baccarat2.push("Score 5-6");
        } else if (totalScore === 7) {
          this.result_baccarat2.push("Score 7");
        } else if (totalScore === 8) {
          this.result_baccarat2.push("Score 8");
        } else if (totalScore === 9) {
          this.result_baccarat2.push("Score 9");
        }

        if (playerPair) {
          this.winner_pair.push("Player Pair");
        }

        if (bankerPair) {
          this.winner_pair.push("Banker Pair");
        }
        // result_baccarat2.push(desc);
      }
      
      this.playerCards = this.playerCards.reverse();
      this.result_baccarat2 = this.result_baccarat2.map((name:any) => `'${name.trim()}'`);

      this.result_baccarat2 = this.result_baccarat2.join(",");
      console.log(`main winner: ${this.win}`);
       console.log(`winner_pair: ${this.winner_pair}`);
      console.log(`result_baccarat2 Cards: ${this.result_baccarat2}`);
    }
  }


  filterBetsByType(event: any) {
      const filterType = (event.target as HTMLInputElement).value;
      console.log('filterType', filterType);
      if (filterType === 'all') {
          this.filter_bets = this.casino_bets;
      } else if (filterType === 'deleted') {
          this.filter_bets = this.casino_bets.filter((bet: any) => bet.from === "deleted");
      } else if (filterType === 'Back') {
          this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Back");
      }
      if (filterType === 'Lay') {
          this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Lay");
      }
      this.totalbets = this.filter_bets.length;
      this.totalAmount = this.filter_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
  }

  closeDialog() {
      this.dialogRef.close();
  }

  dismiss() {
      this.dialogRef.close();
  }

}
